import Cookies from 'js-cookie';

import { MetaValues } from '@/models';

import { stripNulls } from './formatters';
import { getTrustedForm } from './trustedForm';
import { filterSearchParams, scrubEmbedTokenFromUrl, searchParamsToLower } from './url';

export const E2E_SECRET_HEADER_KEY = 'X-E2E-Secret';
export const EXPIRES_KEY = 'session-exp';
export const SESSION_HEADER_KEY = 'session-id';
export const SESSION_KEY = 'mp-session_id';
export const FALLBACK_SESSION_DAYS = 30; // this should be set server side
export const VID_KEY = 'mp-vid';
export const VISITOR_KEY = 'mp-visitor';

// Include Facebook click/browser and Hubspot cookies
const ALLOWED_COOKIES = ['_fbc', '_fbp', 'hubspotutk'];
const getCookies = () => {
  const cookies = Object.entries(Cookies.get());

  return Object.fromEntries(cookies.filter(([key]) => ALLOWED_COOKIES.includes(key)));
};

// GA4's first-party `_ga` cookie stores the client id as `GA1.<version>.<clientId>`, where
// <clientId> is itself `<random>.<timestamp>`. GA4 (Measurement Protocol / Cloud mode) requires
// this client_id to attribute events to a session.
export const getGaClientId = (): string | undefined => {
  const ga = Cookies.get('_ga');
  if (!ga) {
    return undefined;
  }

  const clientId = ga.split('.').slice(2).join('.');
  return clientId || undefined;
};

export const getLoadTime = (): number | undefined => {
  const { performance } = globalThis;
  const performanceEntry = performance?.getEntriesByType?.('navigation')?.[0] as
    | PerformanceNavigationTiming
    | undefined;
  if (!performanceEntry) {
    return undefined;
  }

  // If loadEventEnd is not available yet, use current time
  const loadEventEnd = performanceEntry.loadEventEnd > 0 ? performanceEntry.loadEventEnd : performance.now();
  const startTime = performanceEntry.startTime;

  return Math.round(loadEventEnd - startTime);
};

export function getUrlMetaValues(): MetaValues {
  const { hostname, pathname, search } = location;

  const searchParams = searchParamsToLower(search);

  const cookies = getCookies();

  const newMetaValues: MetaValues = {
    ...cookies,
    ...filterSearchParams(searchParams),
    ...getTrustedForm(),
    ga_client_id: getGaClientId(),
    raw_url: scrubEmbedTokenFromUrl(globalThis.location.href),
    url_domain: hostname,
    url_path: pathname,
  };

  return stripNulls(newMetaValues);
}
